import { formatCompetitionLabel } from './competitionLabel';

type CompetitionNameProps = {
  displayName: string;
  autonomousCommunity?: { name?: string | null; flagUrl?: string | null } | null;
};

/** Competition label preceded by its autonomous community flag (when it has one). */
export const CompetitionName = ({ displayName, autonomousCommunity }: CompetitionNameProps) => (
  <span className="inline-flex min-w-0 items-center gap-2">
    {autonomousCommunity?.flagUrl && (
      <img
        src={autonomousCommunity.flagUrl}
        alt={autonomousCommunity.name ? `Bandera de ${autonomousCommunity.name}` : ''}
        className="h-4 w-6 shrink-0 rounded-sm object-cover"
      />
    )}
    <span className="truncate">{formatCompetitionLabel({ displayName, autonomousCommunity })}</span>
  </span>
);
